import { render, staticRenderFns } from "./SyncIccidLog.vue?vue&type=template&id=227c23b9"
import script from "./SyncIccidLog.vue?vue&type=script&lang=js"
export * from "./SyncIccidLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports